import React from "react";
import { CloudArrowUp, CheckCircle } from "@phosphor-icons/react";
import { Stack, Typography, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const DocumentUploadDisplay = ({ onIconPress, hasUploadedToClientAccount }) => {
  const theme = useTheme();
  return (
    <Stack direction={"row"} alignItems={"center"} gap={"12px"} mt={"3px"}>
      {hasUploadedToClientAccount ? (
        <Stack direction="row" gap={1} alignItems="center">
          <CheckCircle color={theme.palette.success.main} size={16} weight="duotone" />
          <Typography variant="caption" color="success.main">
            Uploaded to client's account!
          </Typography>
        </Stack>
      ) : (
        <IconButton onClick={onIconPress} sx={{ alignSelf: "flex-start" }} size="small">
          <CloudArrowUp color={theme.palette.text.secondary} />
        </IconButton>
      )}
    </Stack>
  );
};

export default DocumentUploadDisplay;
